// Module
var code = "<template class=\"mooring-components-tab\">\n  <require from=\"./buoys-container\"></require>\n  <buoys-container mooring-id.bind=\"data.mooringId\" review-id.bind=\"data.activeReviewId\"></buoys-container>\n</template>\n";
// Exports
export default code;